
const statusGroup = {
    placed:0,
    pending:0,
    cancelled:0,
    delivered:0,
    courierNotFound:0,
    rejected:0,
    confirmed:0,
    allocated:0,
    pickingUp:0,
    picked:0,
    disposed:0,
    returnInTransit:0,
    returned:0,
    droppingOff:0,
    active:0
}

export default statusGroup